import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import { SortDirection } from '../../../models/table-state.model'

@Component({
  selector: 'jml-lib-col-header',
  templateUrl: './col-header.component.html',
  styleUrls: ['./col-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColHeaderComponent implements OnInit, AfterViewInit {
  cdr = inject(ChangeDetectorRef)

  @Input() cssClass: string
  @Input() header: string
  @Input() headerTooltip: string
  @Input() description: string
  @Input() sortable: string
  @Input() field: string
  @Input() sortDirection?: SortDirection = SortDirection.NONE // pre-defined sort direction. If not provided it is set to None.
  @Input() sortingOrder?: number
  @Input() showSortingOrder = false // set to true only for multiSort

  @Output() onSort: EventEmitter<SortDirection> = new EventEmitter<SortDirection>()

  @ViewChild('headerSpan') headerSpan!: ElementRef<HTMLSpanElement>

  SortDirection = SortDirection
  tooltip = ''

  // Binding to set the CSS variable for the sorting order
  @HostBinding('style.--sorting-order')
  get sortingOrderValue() {
    return `"${this.sortingOrder ? this.sortingOrder : ''}"`
  }

  @HostBinding('style.--show-sorting-order')
  get showSortingOrderValue() {
    return this.showSortingOrder === true ? 'visible' : 'hidden'
  }

  ngOnInit() {
    if (!!this.sortDirection) {
      this.sort(this.sortDirection)
    }
  }

  ngAfterViewInit(): void {
    // best way to check for an overflow (shown as 3 dots/ellipsis) is to compare offestWidth with scrollwidth
    // https://stackoverflow.com/questions/36723600/how-to-detect-if-the-text-is-overflowtext-overflow-ellipsis-in-angular-contro

    // the timeout gives Angular the time to render properly before the nativeElements are correctly set
    setTimeout(() => {
      const overflow = this.headerSpan.nativeElement.offsetWidth < this.headerSpan.nativeElement.scrollWidth
      if (this.headerTooltip) {
        this.tooltip = overflow ? `${this.header}: ${this.headerTooltip}` : this.headerTooltip
        this.cdr.markForCheck()
      } else if (overflow) {
        this.tooltip = this.header
        this.cdr.markForCheck()
      }
    })
  }

  sort(sortDirection: SortDirection) {
    this.onSort.emit(sortDirection)
  }
}
